var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useMemo } from 'react';
import { FFDropdown } from '@leapfinance/geebee-component-library';
import { uniqBy } from 'lodash';
import { COUNTRY_DIAL_CODE_WITH_VALIDATIONS } from './countryCodes';
var FFCountryCodeField = function (_a) {
    var countryCodeFieldProps = _a.countryCodeFieldProps, countryCodeComponentProps = _a.countryCodeComponentProps;
    var countryCodeOptions = useMemo(function () {
        return uniqBy(COUNTRY_DIAL_CODE_WITH_VALIDATIONS, 'dial_code').map(function (item) {
            return {
                value: item.dial_code,
                label: item.dial_code
            };
        });
    }, []);
    return (React.createElement(FFDropdown, { fieldProps: __assign({}, countryCodeFieldProps), componentProps: __assign(__assign({ disableClearable: true }, countryCodeComponentProps), { options: countryCodeOptions, textInputProps: __assign({ placeholder: '+91' }, countryCodeComponentProps === null || countryCodeComponentProps === void 0 ? void 0 : countryCodeComponentProps.textInputProps), sx: __assign({ ':hover': {
                    '& .MuiAutocomplete-input': {
                        minWidth: '30px'
                    }
                }, ':focus-within': {
                    '& .MuiAutocomplete-input': {
                        minWidth: '30px'
                    }
                } }, countryCodeComponentProps === null || countryCodeComponentProps === void 0 ? void 0 : countryCodeComponentProps.sx) }) }));
};
export default FFCountryCodeField;
//# sourceMappingURL=FFCountryCodeField.js.map